import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_WIDTH } from './navConfig';

const STORAGE_KEY = 'sidebarCollapsed';

const SidebarContext = createContext(null);

export const SidebarProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'true'
  );

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  }, [collapsed]);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const sidebarWidth = collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  const value = useMemo(
    () => ({ collapsed, toggleCollapsed, sidebarWidth }),
    [collapsed, toggleCollapsed, sidebarWidth]
  );

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
};
